import{Model} from 'ords/dist/model/model';

export class PersonalGoalsSkill extends Model{
}

export const PersonalGoalsSkillModelConfig = {
    name: 'personalGoalsSkill',
    model: PersonalGoalsSkill,
    relations: [
        {name: 'personalgoal', model_name: 'personalGoals', returns_many: false, type: 'belongsToMany'},
    ]
}
